import { Model } from 'core/models';
import { FileTemplateInput } from 'models/FileTemplateInput';
import { Organization } from 'models/Organization';

export class FileTemplate extends Model {

    public id?: number;
    public organizationId?: number;
    public fileId?: number;
    public name?: string;
    public url?: string;
    public fileName?: string;
    public selfDefineInputId?: number;
    public statusId?: number = 1;
    public sample?: string;
    public creatorId?: number;
    public isError?: boolean;
    public organization?: Organization;
    public file?: FileModel;
    public fileTemplateInputs?: FileTemplateInput[];
}

export interface FileModel {
    id?: number;
    fileId?: string | number;
    name?: string;
    url?: string;
    appUserId?: number;
    rowId?: string;
    content?: string;
    mimeType?: string;
    isFile?: boolean;
    key?: any;
    path?: string;
    level?: number;
    isDelete?: boolean;
    clearAction?: (fileId: string | number) => void;
    handleInput?: (e: any) => void;
}
